import { $, $$ } from '../../helpers/shortcuts';
import { getTriggers } from '../../helpers/triggers';
import { onClickOutside } from '../../helpers/click-outside';
import { matchMedia } from '../../helpers/media-queries';

function toggleOverlay(overlayId) {
  const overlay = getOverlayById(overlayId);
  if (!overlay)
    throw new Error(`overlay with overlayId '${overlayId} not found.'`);
  overlay.classList.contains('header-overlay-isvisible')
    ? closeOverlay(overlayId)
    : openOverlay(overlayId);
}

function getOverlayById(overlayId) {
  return $(`.header-overlay[data-overlay-id="${overlayId}"]`);
}

function getOverlayButtonById(overlayId) {
  return $(
    `.header-buttons > [data-trigger="header-overlay"][data-overlay-id="${overlayId}"]`,
  );
}

function getAllOverlays() {
  return $$(`.header-overlay`);
}

function closeOverlay(overlayId) {
  const $overlay = getOverlayById(overlayId);
  if (!$overlay)
    throw new Error(`overlay with overlayId '${overlayId} not found.'`);
  $overlay.classList.remove('header-overlay-isvisible');
  const button = getOverlayButtonById(overlayId);
  button.classList.remove('active');
}

function openOverlay(overlayId) {
  const $overlay = getOverlayById(overlayId);
  if (!$overlay)
    throw new Error(`overlay with overlayId '${overlayId} not found.'`);

  $overlay.classList.add('header-overlay-isvisible');

  const button = getOverlayButtonById(overlayId);
  button.classList.add('active');
  if (matchMedia('large', { mobileFirst: false })) {
    window.scrollTo({ top: 0, left: 0 });
  }
}

function closeAllOverlays() {
  getAllOverlays().forEach(($overlay) => {
    const overlayId = $overlay.getAttribute('data-overlay-id');
    closeOverlay(overlayId);
  });
}

function setOverlayPositions() {
  const $$overlays = getAllOverlays();

  if (matchMedia('large', { mobileFirst: true })) {
    const headerFirstline = $('.header-firstline');
    if (!headerFirstline) return;
    const headerContentWidth = headerFirstline.clientWidth;
    const viewportWidth = $('html').clientWidth;
    const basePositionX = (viewportWidth - headerContentWidth) / 2;

    $$overlays.forEach(($overlay) => {
      $overlay.style.setProperty('right', `${basePositionX}px`);
    });
  } else {
    $$overlays.forEach(($overlay) => {
      $overlay.style.removeProperty('right');
    });
  }
}

function initializeHeaderOverlays() {
  getTriggers('header-overlay').forEach((trigger) => {
    const overlayId = trigger.getAttribute('data-overlay-id');
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      overlayId && toggleOverlay(overlayId);
    });
  });

  getAllOverlays().forEach((overlay) =>
    overlay.addEventListener(
      'transitionend',
      (ev) => {
        if (overlay != ev.target) {
          return;
        }
        if (!overlay.classList.contains('header-overlay-isvisible')) {
          return;
        }
        overlay
          .querySelector(
            '.header-overlay-inner a[href]:not([tabindex="-1"]), .header-overlay-inner input:not([tabindex="-1"]), .header-overlay-inner button:not([tabindex="-1"])',
          )
          .focus();
      },
      false,
    ),
  );

  getAllOverlays().forEach((overlay) => {
    var overlayId = overlay.dataset.overlayId;
    var trigger = getOverlayButtonById(overlayId);

    onClickOutside([trigger, overlay], () => closeOverlay(overlayId));
  });

  window.addEventListener('resize', setOverlayPositions);
  setOverlayPositions();
}

export { initializeHeaderOverlays, toggleOverlay, closeAllOverlays };
